import { useState, useEffect } from 'react';
import { TOUCH_MEDIA_QUERY } from '../config/constants';

/** Reactive touch-device check (matchMedia, guarded for SSR/jsdom). */
export function useIsMobile() {
  const read = () => (typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(TOUCH_MEDIA_QUERY).matches : false);
  const [m, setM] = useState(read);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(TOUCH_MEDIA_QUERY);
    const on = e => setM(e.matches);
    if (mql.addEventListener) mql.addEventListener('change', on); else mql.addListener(on);
    return () => { if (mql.removeEventListener) mql.removeEventListener('change', on); else mql.removeListener(on); };
  }, []);
  return m;
}
